import { render, staticRenderFns } from "./EditionOfPart.vue?vue&type=template&id=7d896487&scoped=true&"
import script from "./EditionOfPart.vue?vue&type=script&lang=js&"
export * from "./EditionOfPart.vue?vue&type=script&lang=js&"
import style0 from "./EditionOfPart.vue?vue&type=style&index=0&id=7d896487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d896487",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VDialog,VIcon,VImg,VOverlay})
